export default "__VITE_ASSET__87ad29c2__"